import { ManifestService, OrderService } from '../services';
import _ from 'lodash';

const namespace = 'manifests/';
export const GET_MANIFESTS = `${namespace}/GET_MANIFESTS`;
export const MANIFESTS_RECEIVED = `${namespace}/MANIFESTS_RECEIVED`;

export const DELETE_MANIFEST = `${namespace}/DELETE_MANIFEST`;

const getManifests = () => {
  return {
    type: GET_MANIFESTS
  }
}

const manifestsReceived = (manifests) => {
  return {
    type: MANIFESTS_RECEIVED,
    manifests
  }
}

export function getAll() {
  return (dispatch, getState) => {
    dispatch(getManifests());
    const state = getState();
    ManifestService.getAll(state.auth.auth).then((response) => {
      dispatch(manifestsReceived(response));
      return response;
    });

  }
}

export function deleteManifest(manifest) {
  return (dispatch, getState) => {
    const state = getState();
    const orders = _.map(manifest.stops, item => item.orders)[0];
    const orderIds = _.map(orders, 'id');
    return ManifestService.deleteManifest(state.auth.auth, manifest.id).then(() => {
      const obj = {
        values: {
          statusId: 3
        },
        orders: orderIds
      };
      return OrderService.updateOrders(state.auth.auth, obj);
    }).catch((e) => { console.log(e)});
  }
}


// WEBPACK FOOTER //
// ./src/actions/ManifestActions.js